import React from 'react'
import { Control } from 'react-redux-form'
import Datetime from 'react-datepicker'

class DateControl extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { model, createFromValue, className, children, ...rest } = this.props

    //console.log("DATE", rest)
    return (
      <Control.custom
        model={model}
        component={Datetime}
        className={className}
        mapProps={{
          onChange: props => v => {
            //console.log("SET", props, v)
            props.onChange(v)
          },
          selected: props => {
            const d = Date.parse(props.viewValue)

            return d
          }
        }}
        {...rest}>
        {children}
      </Control.custom>
    )
  }
}

export default DateControl
